import {Link} from "react-router";

import appImageMobile from "@/assets/images/app-image-mobile.svg";
import appImage from "@/assets/images/app-image.svg";
import DownloadAndroid from "@/assets/images/download-android.svg";
import DownloadIos from "@/assets/images/download-ios.svg";
import uptimeAndroidQR from "@/assets/images/uptime-android-qr.svg";
import uptimeIosQR from "@/assets/images/uptime-ios-qr.svg";
import {Card} from "@/components/card/Card.tsx";

import {ButtonRow} from "../buttonrow/ButtonRow.tsx";
import {StepBodyProps} from "../step/Step.tsx";

import styles from "./StepConnectedBody.module.scss";

export const StepConnectedBody = ({onSubmit, stepsCount, activeStepNr}: StepBodyProps) => {
  const appStoreUrl = "https://apps.apple.com/us/app/uptime-com-website-monitoring/id1176754968";
  const googlePlayUrl = "https://play.google.com/store/apps/details?id=com.apppartner.uptime.uptime&pli=1";
  const uptimeSupportUrl = "https://support.uptime.com/";

  const submitStep = (back?: boolean) => {
    if (back) {
      return onSubmit(activeStepNr - 1, true);
    }
    onSubmit(activeStepNr + 1, true);
  };

  return (
    <div className={styles.connectedWrapper}>
      <div className={styles.getApp}>
        <div>
          <picture className={styles.appImg}>
            <source srcSet={appImageMobile} media="(max-width: 768px)" />
            <img src={appImage} alt="app" />
          </picture>
        </div>
        <div className={styles.deviceBoxes}>
          <Card variant="white" className={styles.deviceBox}>
            <a href={appStoreUrl} target="_blank">
              <img src={DownloadIos} alt="App Store" />
            </a>
            <img src={uptimeIosQR} alt="App Store QR Code" />
          </Card>
          <Card variant="white" className={styles.deviceBox}>
            <a href={googlePlayUrl} target="_blank">
              <img src={DownloadAndroid} alt="Google Play" />
            </a>
            <img src={uptimeAndroidQR} alt="Google Play QR Code" />
          </Card>
        </div>
      </div>
      <div className={styles.helpLine}>
        <span>Need more help?</span> <br className="d-md-none" />
        <a href={uptimeSupportUrl} target="_blank">
          View Our Help Center
        </a>{" "}
        or{" "}
        <Link to="/contact" target="_blank">
          Contact Us
        </Link>
      </div>
      <ButtonRow onSubmit={submitStep} stepsCount={stepsCount} activeStepNr={activeStepNr} />
    </div>
  );
};
